<template>
	<div class="container">
		<!--页面开始-->
		<div class="step_box">
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_1.webp')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit"></div>
				<div class="step_txt">
					Tube holder
				</div>
			</div>
			
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_2.webp')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit"></div>
				<div class="step_txt">
					Test cassette
				</div>
			</div>
			
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_3.webp')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit"></div>
				<div class="step_txt">
					Tube with sample processing solution
				</div>
			</div>
			
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_4.webp')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit"></div>
				<div class="step_txt">
					Swab
				</div>
			</div>
			
			<div class="step_el">
				<div class="img_box">
					<van-image
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/pdf/00.webp')"
					  @click.stop.prevent="showBig"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
				</div>
				<div class="tit"></div>
				<div class="step_txt">
					QRI
				</div>
			</div>
		</div>
		<div class="btn_box">
			<van-button
				type="primary"
				block
				round
				color="linear-gradient(to right, #a74af2, #5949f2)"
				@click="goStepTwo"
			>
				Next
			</van-button>
		</div>
		<!--页面开始-->
		<!--遮罩-->
		<!-- <van-dialog v-model="isShowZz" title="Confirm" :showConfirmButton="false" :showCancelButton="false">
			<div class="countdown_box">
				<div class="count_txt">Some browsers have pop-up advertising, which has nothing to do with our company</div>
				<div class="count_btn" ref="toggle1">OK</div>
			</div>
		</van-dialog> -->
		<!--遮罩-->
	</div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
	components:{
		//
	},
	data() {
		return {
			//isShowZz: true,  //常亮弹框
			imgList: [
				require('@/assets/img/pdf/00.webp'),
			]
		}
	},
	beforeCreate() {
		document.querySelector('body').setAttribute('style', 'background-color:#fbfbfb;');
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		goStepTwo() {
			this.$router.push({path:'/steptwo'});
		},
		//展示大图
		showBig() {
			let that = this;
			ImagePreview({
			  images: that.imgList,
			});
		}
	},
	beforeDestroy() {
		document.querySelector('body').removeAttribute('style');
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
	
.img_box{
	padding: 1rem 1rem 0 1rem;
}
	
.container{
	/* position: absolute;
	height: 100%; */
	/* background-color: #fbfbfb; */
}
.step_box .step_el{
	background-color: #ffffff;
	margin-bottom: 0.32rem;
	border-radius: 0.32rem;
	box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
	overflow: hidden;
	position: relative;
	border: 1px solid #E9E9E9;
}
.step_box .step_el:last-child{
	margin-bottom: 0;
}
/* .step_box, .btn_box{background-color: #fbfbfb;} */
.step_box{padding-bottom: 0.64rem !important;}
/*步骤下说明文字*/
.step_txt{
	padding: 0.533rem 0.64rem 0.427rem 0.64rem;
	color: #333333;
}


.countdown_box{
	padding:0.2rem 0.5rem 0.3rem 0.5rem;
	text-align: center;
	color: #666666;
}
.countdown_box .count_btn{
	margin-top: 0.5rem;
	padding-top: 0.3rem;
	border-top: 1px solid #f8f8f8;
	color: #333333;
}

.step_box{
	position: relative;
	padding: 0.32rem 0.32rem 0 0.32rem;
}
.step_box img{
	width: 100%;
	height: auto;
}
.step_box .step_el{
	position: relative;
}
.step_box .step_el:last-child{
	padding-bottom: 0;
}
.step_box .step_el .tit{
	position: absolute;
	top: 0.32rem;
	left: 0.32rem;
	font-size: 0.533rem;
	color: #333333;
	font-weight: bold;
}
.btn_box{padding: 0rem 0.9rem 1.107rem 0.9rem;}
.step_box img, .btn_box img{width: 100%;}


>>> .van-button{height: 1.2rem;}
>>> .van-button__text{color: #ffffff;font-size: 0.48rem;font-weight: bold;}
</style>
